import { AgendaApiResponse } from '@/apps/agenda/types';
import { transformAfsprakenToAgenda } from '@/apps/agenda/utils/transformAfsprakenToAgenda';
import { Afspraak } from '@/queries/agenda/types';
import { managedPageQueryMeta, throwIfResponseNotOk } from '@/queries/queryErrorHandling';
import { useFetchWithAuth } from '@/queries/useFetchWithAuth';
import { QueryFunction, useQuery } from '@tanstack/react-query';

export const AGENDA_QUERY_KEY = ['useGetAgendaApi'];

const useGetAgendaApi = (enabled = true) => {
  const { fetchWithAuth } = useFetchWithAuth();

  const fetcher: QueryFunction<AgendaApiResponse> = async () => {
    const response = await fetchWithAuth('/agenda/afspraak');
    throwIfResponseNotOk(response, `Ophalen van agenda is mislukt (${response.status}).`);
    const afspraken: Afspraak[] = await response.json();
    return transformAfsprakenToAgenda(Array.isArray(afspraken) ? afspraken : []);
  };

  return useQuery({
    queryKey: AGENDA_QUERY_KEY,
    queryFn: fetcher,
    enabled,
    refetchInterval: 30_000,
    meta: managedPageQueryMeta,
  });
};

export default useGetAgendaApi;
